export default "__VITE_ASSET__a1c9dd1c__"